import { gql } from "@apollo/client";

const GET_PRICE_MODEL = gql`
query getPriceModel($priceModelId: Int!) {
	companyAdminContext {
		pricingModels {
			pricingModel(pricingModelId: $priceModelId) {
				description
				name
				pricingModelId

				pricingProperties {
					defaultArtNo
					displayMode
					id
					label
					name
					pricingPropertyValues {
						pricingPropertyValueId
						name
						artNo
						hasComment
						defaultQuantity
						selectedByDefault
					}
				}
			}
		}
	}
}`;

export default GET_PRICE_MODEL;